import { UrlSegment, UrlSegmentGroup } from '@angular/router';

export const hasPath = (segmentGroup, path) => {
    const segments = segmentGroup.segments;
    if (segments && segments.length > 1) {
        const last = segments.length - 1;
        return segments[last].path.includes(path);
    }
    return false;
};

export const filteredWallMatcher = (url: UrlSegment[], segmentGroup: UrlSegmentGroup) => {
    if (
        hasPath(segmentGroup, 'accessoires-') ||
        hasPath(segmentGroup, 'soldes-') ||
        hasPath(segmentGroup, 'telephone-portable') ||
        hasPath(segmentGroup, 'hotspot-tablette')
    ) {
        return {
            consumed: url,
            posParams: {
                path: url[0],
            },
        };
    }
    return null;
};

export const accCategoryMatcher = (url: UrlSegment[], segmentGroup: UrlSegmentGroup) => {
    const segments = segmentGroup.segments;
    if (segments && segments.length > 1) {
        const last = segments.length - 1;
        if (segments[last].path.includes('accessoires-') && !segments[last].path.includes('soldes-')) {
            return {
                consumed: url,
                posParams: {
                    path: url[0],
                },
            };
        }
    }
    return null;
};
// @todo faire une méthode
export const soldesCategoryMatcher = (url: UrlSegment[], segmentGroup: UrlSegmentGroup) => {
    const segments = segmentGroup.segments;
    if (segments && segments.length > 1) {
        const last = segments.length - 1;
        if (segments[last].path.includes('soldes-')) {
            return {
                consumed: url,
                posParams: {
                    path: url[0],
                },
            };
        }
    }
    return null;
};

export const mobileCategoryMatcher = (url: UrlSegment[], segmentGroup: UrlSegmentGroup) => {
    const segments = segmentGroup.segments;
    if (segments && segments.length > 1) {
        const last = segments.length - 1;
        if (segments[last].path.includes('telephone-portable')) {
            return {
                consumed: url,
                posParams: {
                    path: url[0],
                },
            };
        }
    }
    return null;
};

export const aloneProductMatcher = (url: UrlSegment[], segmentGroup: UrlSegmentGroup) => {
    const segments = segmentGroup.segments;
    if (segments && segments.length > 1) {
        const last = segments.length - 1;
        if (
            (segments[0].path.includes('accessoires') && !segments[last].path.includes('accessoires-')) ||
            segments[0].path.includes('hotspot-tablette')
        ) {
            return {
                consumed: url,
                posParams: {
                    path: url[0],
                },
            };
        }
    }
    return null;
};

export const mobileContractMatcher = (url: UrlSegment[], segmentGroup: UrlSegmentGroup) => {
    const segments = segmentGroup.segments;
    if (segments && segments.length > 2) {
        if (segments[2].path.includes('contrats')) {
            return {
                consumed: url,
                posParams: {
                    path: url[0],
                },
            };
        }
    }
    return null;
};

export const matchPath = (path: string, url: UrlSegment[]) => {
    if (url.length === 1 && url[0].path.includes(path)) {
        return {
            consumed: url,
            posParams: {
                path: url[0],
            },
        };
    }
    return null;
};

export const matchPhonesWall = (url: UrlSegment[]) => matchPath('telephone-portable', url);

export class AppRoutingMatchers {}
